import Model3d from '../../components/model3d';
function showModel (data) {

  const { model3d } = this;
  
  const model3dKey = 'model3d' + data.model_id;

  if (this[model3dKey]) {
    this[model3dKey].show();
    return;
  }
  const newModel3d = new Model3d({
    wrapper: this.$container.get(0),
    ...data,
  });
  this[model3dKey] = newModel3d;
}

export default {
  showModel
}